/**
 * Firebase Client SDK Configuration
 * For Google OAuth authentication
 */
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

// Firebase config from environment variables
// These should be set in .env file
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDSFjnsT3ilLlSW1EbhrxEJZBE1i0LWgOs',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'n2nai-ecourt.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'n2nai-ecourt',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'n2nai-ecourt.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '664499042636',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:664499042636:web:19dc0db337baad1b0577e9',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Google Auth Provider - Cấu hình cho popup window
export const googleProvider = new GoogleAuthProvider()
// Đảm bảo sử dụng popup window, không redirect
googleProvider.setCustomParameters({
  prompt: 'select_account'
})
// Thêm scopes cần thiết
googleProvider.addScope('profile')
googleProvider.addScope('email')

export default app
